function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import React from 'react';
import { shape, string } from 'prop-types';
import { useStoreSwitcher } from '@magento/peregrine/lib/talons/Header/useStoreSwitcher';
var StoreSwitcher = _ref => {
  var {
    opposite,
    fullLang
  } = _ref;
  var {
    availableStores,
    currentStoreCode,
    handleSwitchStore
  } = useStoreSwitcher();
  if (!availableStores || availableStores.size <= 1) return null;
  var oppositeStoreCode = () => {
    var storeCode = '';
    for (var k of availableStores.keys()) {
      if (k != currentStoreCode) storeCode = k;
    }
    return storeCode;
  };
  var oppositeStore = oppositeStoreCode();
  var storeCode = opposite ? oppositeStore : currentStoreCode;
  var label = storeCode.toUpperCase();
  if (fullLang) {
    if (label === "FR") {
      label = "Français";
    } else {
      label = "English";
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    onClick: /*#__PURE__*/_asyncToGenerator(function* () {
      yield handleSwitchStore(oppositeStore);
    })
  }, label);
};
export default StoreSwitcher;
StoreSwitcher.propTypes = {
  classes: shape({
    groupList: string,
    groups: string,
    menu: string,
    menu_open: string,
    menuItem: string,
    root: string,
    trigger: string
  })
};